import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_communitymarketing_report_02_2023_WP.png'

const paperInfo = {
    paperName: 'コミュニティマーケティングレポート コミュニティ関連施策従事者向けアンケート【コミュニティ施策の効果編】',
    thumbnail,
    feature1: 'コミュニティ関連施策の取り組みにおける効果の実態',
    feature2: 'ビジネスモデル別のコミュニティ施策の取り組み詳細',
    description:
        '昨今にわかに注目を集める「コミュニティ施策」。実際に取り組む企業は何を目的に、どのような手法で行っているのかについて調査したレポートです。自社でコミュニティ施策に取り組む際の参考情報を探している方は必読です。',
    formSrc: 'https://go.commmune.jp/l/915341/2023-01-26/mm629',
    type: 'pardot'
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
